import React from 'react'
import { graphql } from 'gatsby'
import { Image } from '../../components/image'
import { UnorderedList } from '../../components/list'
import {
  Container,
  Intro,
  Subtitle,
  Title,
  Section,
} from '../../components/page'

import * as styles from './ambassadors-about.module.scss'

export type AmbassadorsAboutProps = Queries.AmbassadorsAboutFragment

export const AmbassadorsAbout = ({
  title,
  text,
  subtitle,
  perks,
  image,
}: AmbassadorsAboutProps) => {
  return (
    <Section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.image}>
          <Image image={image} alt={image?.title!} loading="eager" />
        </div>
        <div className={styles.text}>
          <Title>{title}</Title>
          <Intro>{text?.text}</Intro>
        </div>
        <div className={styles.list}>
          <Subtitle>{subtitle}</Subtitle>
          <UnorderedList>
            {perks?.map((perk, index) => (
              <li key={index}>{perk}</li>
            ))}
          </UnorderedList>
        </div>
      </Container>
    </Section>
  )
}

export const AmbassadorsAboutFragments = graphql`
  fragment AmbassadorsAboutImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData
  }
  fragment AmbassadorsAbout on ContentfulAmbassadorsAbout {
    __typename
    id
    title
    text {
      text
    }
    subtitle
    perks
    image {
      ...AmbassadorsAboutImage
    }
  }
`
